import { GetPjTrainingCoursesQuery, useGetPjTrainingCoursesQuery } from '~/graphql/catalog/queries';
import { Types } from '~/graphql';

export const getPjTrainingCourseVariables = () => {
    return {
        searchQuery: {
            filters: [
                {
                    field: 'brandType',
                    operation: Types.SearchFilterOperation.Equal,
                    value: [Types.ProductBrand.PjTraining]
                }
            ],
            pageSize: 1
        }
    };
};

export type PjTraningCourse = GetPjTrainingCoursesQuery['contentsV3']['data'][number];
export const useGetPjTraningCourse = () => {
    const { data, loading, error } = useGetPjTrainingCoursesQuery({
        variables: getPjTrainingCourseVariables(),
        nextFetchPolicy: 'cache-only'
    });

    // Return the first course
    return {
        course: data?.contentsV3.data[0],
        loading,
        error
    };
};
